import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Switch,
  IconButton,
  Typography,
  colors,
} from "@material-ui/core";
import {
  Edit as EditIcon,
  Download as DownloadIcon,
  Print,
  Receipt,
  Description,
  FitnessCenter,
  Favorite,
  Code,
} from "@material-ui/icons";
import TemplateTest from "./test-template";
import PrintingButtons from "../../../../components/controls/PrintingButtons";
import AddTemplate from "./AddTemplate";
import { uri } from "../../../../help/Api";
import { useTranslation } from "react-i18next";
// import AddTemplate from "./AddTemplate"; // Make sure the AddTemplate component is in the same directory
// import InvoiceHome from "../../pages/test-templater";
export const TemplateIcons = [
  { name: "Print", component: Print },
  { name: "Receipt", component: Receipt },
  //   { name: "School", component: School },
  { name: "Discription", component: Description },
  { name: "FitnessCenter", component: FitnessCenter },
  { name: "Favorite", component: Favorite },
  { name: "Code", component: Code },
];
const TemplateTable = () => {
  const { t } = useTranslation(["forms"]);
  const [templates, setTemplates] = useState([]);
  const [editingTemplate, setEditingTemplate] = useState(null);

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    try {
      const response = await axios.get(`${uri}templates`);
      setTemplates(response.data);
    } catch (error) {
      console.error("Error fetching templates", error);
    }
  };

  const handleEdit = (template) => {
    setEditingTemplate(template);
  };

  const handleDownload = async (fileName) => {
    try {
      const response = await axios.get(
        `${uri}PrintTemplates/download-template/${fileName}`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading file", error);
    }
  };

  const handleUpdateComplete = () => {
    setEditingTemplate(null);
    fetchTemplates();
  };
  const SelectedIconComponent = (selectedIcon) => {
    const IconCompo =
    TemplateIcons.find((icon) => icon.name === selectedIcon)?.component || null;
    return IconCompo != null ? <IconCompo /> : <></>;
  };
  return (
    <div >
      {editingTemplate ? (
   
        <AddTemplate
          existingTemplate={editingTemplate}
          onSubmit={handleUpdateComplete}
        />
      ) : (
        <TableContainer component={Paper}>
          <Table aria-label="a dense table">
            <TableHead>
              <TableRow style={{
              backgroundColor: colors.teal[100],
              color: "#fff",
            }}>
                <TableCell>{t("template-name")}</TableCell>
                <TableCell>{t("template-icon")}</TableCell>
                {/* <TableCell>State</TableCell> */}
                <TableCell>{t("actions")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {templates.map((template) => (
                <TableRow key={template.Id}>
                  <TableCell>{template.Name}</TableCell>
                  <TableCell>
                    {template.IconName && (
                      <div style={{ marginTop: "5px", textAlign: "center" }}>
                        {SelectedIconComponent(template.IconName)}
                      </div>
                    )}
                    {/* {SelectedIconComponent && (
                      <div style={{ marginTop: "20px", textAlign: "center" }}>
                        <SelectedIconComponent selectedIcon={template.iconName} style={{ fontSize: 40 }} />
                      </div>
                    )} */}
                  </TableCell>
                  {/* <TableCell>
                    <Switch checked={template.State} readOnly color="primary" />
                  </TableCell> */}
                  <TableCell>
                    <Button variant="text" onClick={() => handleEdit(template)}>
                      {t("edit-template")}
                    </Button>
                    <Button
                      variant="text"
                      onClick={() => handleDownload(template.FileName)}
                    >
                      {t("download-template")}
                    </Button>
                    <TemplateTest fileName={template.FileName} 
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default TemplateTable;
